var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { TheGraphClient, toEthereumAddress } from '@streamr/utils';
import shuffle from 'lodash/shuffle';
import { Lifecycle, scoped } from 'tsyringe';
import { LoggerFactory } from '../utils/LoggerFactory';
let OperatorRegistry = class OperatorRegistry {
    theGraphClient;
    logger;
    constructor(theGraphClient, loggerFactory) {
        this.theGraphClient = theGraphClient;
        this.logger = loggerFactory.createLogger('OperatorRegistry');
    }
    async findRandomNetworkEntrypoints(maxEntryPoints, maxQueryResults, maxHeartbeatAgeHours) {
        const createQuery = () => {
            return {
                query: `{
                    operators(
                        orderBy: latestHeartbeatTimestamp
                        orderDirection: desc
                        first: ${maxQueryResults}
                        where: {
                            latestHeartbeatMetadata_contains: "\\"tls\\":true", 
                            latestHeartbeatTimestamp_gt: "${Math.floor(Date.now() / 1000) - (maxHeartbeatAgeHours * 60 * 60)}"
                        }
                    ) {
                        id
                        latestHeartbeatMetadata
                    }
                }`
            };
        };
        const operatorMetadatas = this.theGraphClient.queryEntities(createQuery);
        const peerDescriptors = [];
        for await (const operator of operatorMetadatas) {
            peerDescriptors.push(JSON.parse(operator.latestHeartbeatMetadata));
        }
        const picked = shuffle(peerDescriptors).slice(0, maxEntryPoints);
        this.logger.debug(`Found ${peerDescriptors.length} network entrypoints, picked ${picked.length}`, { picked });
        return picked;
    }
    async findOperatorsOnStream(streamId, maxQueryResults, maxHeartbeatAgeHours) {
        const query = {
            query: `{
                stream(id: "${streamId}") {
                    sponsorships(where: { isRunning: true }) {
                        stakes(first: ${maxQueryResults}, orderBy: updateTimestamp, orderDirection: desc) {
                            operator (
                                where: {
                                    latestHeartbeatMetadata_contains: "\\"tls\\":true", 
                                    latestHeartbeatTimestamp_gt: "${Math.floor(Date.now() / 1000) - (maxHeartbeatAgeHours * 60 * 60)}"
                                }
                            ) {
                                id
                                latestHeartbeatMetadata
                            }
                        }
                    }
                }
            }`
        };
        const queryResult = await this.theGraphClient.queryEntity(query);
        const operatorPeerDescriptors = queryResult.stream.sponsorships
            .flatMap((sponsorship) => sponsorship.stakes
            .map((stake) => ({
            operatorId: toEthereumAddress(stake.operator.id),
            peerDescriptor: JSON.parse(stake.operator.latestHeartbeatMetadata)
        })));
        return operatorPeerDescriptors;
    }
};
OperatorRegistry = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [TheGraphClient,
        LoggerFactory])
], OperatorRegistry);
export { OperatorRegistry };
//# sourceMappingURL=OperatorRegistry.js.map